// extracted by css-extract-rspack-plugin
export default {"navButton":"uOLCH","avatarStack":"aFXFu","channelAvatar":"M9FF6","detailsTable":"EDyie"};